var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertOctagon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#alert-octagon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.55 1.667h6.9l4.883 4.883v6.9l-4.883 4.883h-6.9L1.667 13.45v-6.9L6.55 1.667ZM10 13.333h.008M10 6.667V10"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alert-octagon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
SvgAlertOctagon.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertOctagon);
export default ForwardRef;